import React, { useEffect, useState } from "react";
import banner from "../../../assets/images/Cairo.jpg";
import './Banner.scss';
import {Link, useLocation} from "react-router-dom";

const Banner = () => {
  const [isRoot, setIsRoot] = useState(false);
  const location = useLocation();

  useEffect(() => {
    console.log('loc', location);
    location.pathname == "/" ? setIsRoot(true) : setIsRoot(false);
  }, [location]); 
  
  let height = isRoot ? { height: '200px' } : { height: '100px' };
  console.log('w', isRoot);
  return(
    <div className="banner">
      <img src={banner} alt="Ship blueprint" className="banner-img" style={height} />
       <div className="banner-text">
         &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  <Link to={"./../"}>
           eTIC Information Gateway For NPS Staff
       </Link>
        </div>
    </div>
  );
}

export default Banner;